export function retryApiCall(apiCall, maxRetries = 3, initialDelay = 1000) {
  return new Promise((resolve, reject) => {
    const attempt = (retryCount) => {
      apiCall()
        .then(resolve)
        .catch((error) => {
          console.log("retryApiCall error", error);
          if (retryCount < maxRetries) {
            const delay = initialDelay * Math.pow(2, retryCount);
            console.log(`Retrying... Attempt ${retryCount + 1}, next retry in ${delay}ms`);
            setTimeout(() => attempt(retryCount + 1), delay);
          } else {
            reject(error);
          }
        });
    };

    attempt(0);
  });
}
